<template>
  <div class="man_list">
    <div class="info_text" v-for="(item,index) in fjData.list" :key="index">
      <a><img src="../../../../public/img/addProject/excel.png"></a>
      <a>{{item.fileName}}</a>
      <img v-if="fjData.isShowDel" class="del" src="../../../../public/img/addProject/delete.png">
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
      }
    },
    props:['fjData']

  }
</script>

<style lang="scss" scoped>
  .info_text {
    font-size: 12px;
    color: rgba(25, 31, 37, 0.8);
    background: rgba(245, 247, 250, 1);
    border-radius: 2px;
    margin-bottom: 12px;
    height: 40px;
    position: relative;
    & a {
      line-height: 40px;
      & img {
      width: 15px;
      height: 19px;
      margin-left: 18px;
      margin-right: 8px;
      vertical-align: middle;
    }
    }
		.del{
      position: absolute;
      top:14px;
      right: 16px;
      width: 12px;
      height: 12px;
      cursor: pointer;
		}
  }

  .man_list {
    align-content: center
  }
</style>
